import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminRbac } from '../../contexts/AdminRbacContext';
import { Spinner } from '../ui';

type Props = {
  permission?: string;
  anyOf?: string[];
  children: React.ReactNode;
};

/**
 * Route guard — waits for RBAC to load, then redirects to /admin/forbidden if missing.
 * Must not deny before the first /me/permissions response (avoids Super Admin → 403 flash).
 */
const RequirePermission: React.FC<Props> = ({ permission, anyOf, children }) => {
  const { can, canAny, isLoading, isReady } = useAdminRbac();

  if (isLoading || !isReady) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '40vh' }}>
        <Spinner />
      </div>
    );
  }

  const allowed = permission ? can(permission) : anyOf ? canAny(anyOf) : true;

  if (!allowed) {
    return <Navigate to="/admin/forbidden" replace />;
  }

  return <>{children}</>;
};

export default RequirePermission;
